// extracted by mini-css-extract-plugin
module.exports = {"root":"_6xAdt","bg":"_2eYPq"};